/**
 * Built-in light language packs the app ships. Importing this module registers
 * their app-shell (control) halves; their engine halves (procedures + docs) are
 * registered by the LSP server (`@archlang/engine`'s `sloLanguagePack`). Kept as
 * a side-effecting bootstrap so the app entry opts in with a single import.
 *
 * Controls are inert until a matching aspect key is present (they only swap the
 * inspector editor for that key), so registering them app-wide adds no noise.
 */
import { registerAspectControl } from "./aspectControlRegistry.js";
import { SloAspectControl } from "./SloAspectControl.js";

let registered = false;

/** Register the built-in aspect controls once (idempotent). */
export function registerBuiltinLanguagePacks(): void {
  if (registered) return;
  registered = true;
  registerAspectControl({ aspectKey: "slo", Editor: SloAspectControl });
  registerAspectControl({ aspectKey: "observed", Editor: SloAspectControl });
}
